/**
 * Iter 311 — Permissions granulaires.
 *
 * usePermissions(user) renvoie un helper `has(cap)` qui retourne true si
 * l'utilisateur a la capabilite donnee :
 *   - super_admin / hyperadmin : toujours true
 *   - store_admin              : caisse incluse pour ses magasins ; sinon
 *                                user.extra_permissions
 *   - autres roles             : false
 *
 * Exemple :
 *   const { has } = usePermissions(user);
 *   if (has('view_payslips')) { ... }
 */

const ALWAYS_GRANTED_ROLES = new Set(['super_admin', 'hyperadmin']);
export const CASH_CAPABILITIES = ['view_cash', 'manage_cash_registers', 'manage_cash_closing', 'manage_cash_deposit'];

export function userHasCapability(user, capability) {
  if (!user || !user.role) return false;
  if (ALWAYS_GRANTED_ROLES.has(user.role)) return true;
  if (user.role !== 'store_admin') return false;
  if (CASH_CAPABILITIES.includes(capability)) return true;
  const extra = Array.isArray(user.extra_permissions) ? user.extra_permissions : [];
  return extra.includes(capability);
}

export function usePermissions(user) {
  return {
    has: (capability) => userHasCapability(user, capability),
  };
}

export default usePermissions;
